<template>
	<div>
        <el-table :data="list" :highlight-current-row="true" class="zdxx-table">
            <el-table-column label="操作时间">
                <template slot-scope="{ row }">
                    <span> {{ row.opDateStr }}&nbsp;{{ row.opTimeStr }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="comment" label="操作内容" width="600">
            </el-table-column>
            <el-table-column prop="comment" label="变更明细" >
                <template slot-scope="{ row }">
                    <span class="a-c-blue font-point" v-if="row.afterJson" @click="showChangeContent(row)">查看</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column prop="toStateText" label="状态">
            </el-table-column>
            <el-table-column prop="opUserRealName" label="操作人">
            </el-table-column>
        </el-table>
        <el-dialog
            title="变更明细详情"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="1000px">
            <div class="formContent">
                <el-table :data="changeTableData">
                    <el-table-column label="">
                        <template slot-scope="{ row }">
                            <span>{{ row.changeItemName || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改前">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'ammeterInfoList'">{{ row.oldVal || '-' }}</span>
                            <div v-else class="a-flex-cfsfs a-w-100" style="align-items: flex-start">
                                <span v-for="(item,index) in row.oldVal" :key="index">电表号：{{ item.ammeterNumber }}，比例：{{ (item.ratio * 100).toFixed(2) }}%</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="修改后">
                        <template slot-scope="{ row }">
                            <span v-if="row.keyVal != 'ammeterInfoList'">{{ row.newVal || '-' }}</span>
                            <div v-else class="a-flex-cfsfs a-w-100" style="align-items: flex-start">
                                <span v-for="(item,index) in row.newVal" :key="index">电表号：{{ item.ammeterNumber }}，比例：{{ (item.ratio * 100).toFixed(2) }}%</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
	export default {
		components: {},
		props: {
			stationId: {
				required: true
			},
		},
		data() {
			return {
				list: [],
				pageParam: '',
                dialogVisible: false,
                changeTableData: [],
                changeContentKeys: {
                    "ammeterInfoList": "站点电表",
                },
			}
		},

		watch: {
			stationId: {
				handler(val) {
					if (val) {
						this.getHistory();
					}
				},
			}
		},
		methods: {
			getHistory(data) {
				this.$Axios._get({
					url: this.$Config.apiUrl.getStationTimeLine,
					params: {
						stationId: this.stationId
					}
				}).then(({
					data
				}) => {
					this.list= data
				})
			},
            showChangeContent (row) {
                try {
                    let changeContent = JSON.parse(row.afterJson)
                    let changeContentOld = JSON.parse(row.beforeJson)
                    let changeTableData = []
                    for (const key in this.changeContentKeys) {
                        if (Object.hasOwnProperty.call(this.changeContentKeys, key)) {
                            let newVal = changeContent[key] || '', oldVal = changeContentOld[key] || ''
                            let isChange = changeContent[key] == changeContentOld[key] ? false : true
                            if(key == 'ammeterInfoList') {
                                if(newVal.length != oldVal.length) {
                                    isChange = true
                                }else {
                                    isChange = this.arraysEqual(newVal, oldVal)
                                }
                            }
                           
                            changeTableData.push({
                                changeItemName: this.changeContentKeys[key],
                                keyVal: key,
                                newVal: newVal,
                                oldVal: oldVal,
                                isChange: isChange
                            })
                        }
                    }
                    this.changeTableData = changeTableData.filter(res=>{
                        return res.isChange
                    })
                    this.dialogVisible = true
                } catch (error) {
                    this.$message.error('解析失败')
                    console.log(error);
                }
                
            },
            arraysEqual (arr1, arr2) {
                for (let index = 0; index < arr1.length; index++) {
                    const item = arr1[index];
                    let targetItem = arr2.find(res=>{
                        return res.companyId == item.companyId && res.ratio == item.ratio && res.payCompany == item.payCompany
                    })
                    if(!targetItem) {
                        return(true)
                    }
                }
                return false
            },
		}
	}
</script>
<style lang="scss" scoped>

</style>
